import React, { useState, useEffect } from "react";
import { Table, Tag, Tooltip, Spin, Button, Input } from "antd";
import { getCrawlDocsList, fetchAttachmentURL } from "../../API/api";
import { momentit } from "../../utils";
import {
  DownloadOutlined,
  SyncOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const containerStyles={
  borderColor: '#E0E2E6',
  boxShadow: '0px 1px 2px 0px #1018280D',
  color:'#5C667B !important',
  zIndex:'0',
  width:"80%"
}
export default function CrawlDocsTable() {
  const [rows, setRowData] = React.useState([]);
  const [origRows, setOrigRowData] = React.useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isRefreshing, setRefreshing] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const [tabSearch, settabSearch] = useState('');
  const onChangeFilterStr = (str) => {
    console.log("str",str)
    settabSearch(str);
    if (str === "") {
      setRowData(origRows);
    } else {
      let filteredData = origRows.filter((obj) => {
        if (obj?.jobId?.toLowerCase()?.includes(str.toLowerCase())) {
          return obj;
        }
      });
      setRowData(filteredData);
    }
  };
  const renderTitle = (title, position = 'center') => {
    return (
      <div style={{ textAlign: position }}>
        <span style={{ fontWeight: "500", fontSize: "18px" }}>{title}</span>
      </div>
    );
  };
  const renderPara = (title, position) => {
    return (
      <div style={{ textAlign: position }}>
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
        }}>{title}</span>
      </div>
    );
  };
  const renderUrl = (url) => {
    return (
      <div style={{ textAlign: "start" }}>
        <a
          style={{ fontWeight: "300", fontSize: "12px", textDecoration: 'none' }}
          href={url}
          target="_blank"
        >
          {url}
        </a>
      </div>
    );
  };
  const tooltipTitle = (str) => {
    return (
      <span style={{ color: 'black' }}>{str}</span>
    )
  }
  const renderActionButton = (data) => {
    const download = () => {
      let payload = {
        name: `${data.soId}.log`,
        type: "log",
        crawling: true,
      };
      fetchAttachmentURL(payload).then((res) => {
        if (res === undefined) return;
        if (res.data.success) {
          const linkSource = `${res.data.data.src}`;
          const downloadLink = document.createElement("a");
          document.body.appendChild(downloadLink);
          downloadLink.href = linkSource;
          downloadLink.target = "_self";
          downloadLink.download = data.soId;
          downloadLink.click();
        }
      });
    };
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          shape="circle"
          type="dashed"
          icon={<DownloadOutlined />}
          onClick={() => download("hello")}
        />
      </div>
    );
  };
  const refreshData = () => {
    if (!isRefreshing) {
      setRefreshing(true);
      fetchData();
    }
  };
  const fetchData = () => {
    settabSearch('');
    setLoading(true);
    getCrawlDocsList().then((res) => {
      if (res === undefined) return;
      let newData = res.data.data.filter((obj) => {
        obj.childLink = obj.children.toString();
        delete obj.children;
        return obj;
      });
      setTableParams({
        pagination: {
          current: 1,
          pageSize: 10,
        },
      });
      setRowData(newData);
      setOrigRowData(newData);
      setLoading(false);
      setRefreshing(false);
    });
  };

  const columns = [
    {
      title: renderTitle("Name", 'start'),
      dataIndex: "jobId",
      width: "12%",
      render: (_, row) => (
        <span style={{
          wordBreak: 'break-word', overflowWrap: 'break-word',

          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
        }}>{renderPara(row.jobId, 'start')}</span>
      ),
    },
    {
      title: renderTitle("Submitted", 'start'),
      dataIndex: "createdDate",
      width: "12%",
      render: (_, row) => (
        <>
          <span>
            {renderPara(momentit(new Date(row.createdDate).getTime()), 'start')}
          </span>
        </>
      ),
    },
    {
      title: renderTitle("Last Checked", 'start'),
      dataIndex: "modifiedDate",
      width: "12%",
      render: (_, row) => (
        <>
          <span style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
          }}>
            {renderPara(momentit(new Date(row.modifiedDate).getTime()), 'start')}
          </span>
        </>
      ),
    },
    {
      title: renderTitle("URL Link", 'start'),
      dataIndex: "url",
      // width: "40%",
      render: (_, row) => (
        <>
          <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word', }}>{renderUrl(row.url)}</span>
        </>
      ),
    },
    Table.EXPAND_COLUMN,
    {
      title: renderTitle("Frequency"),
      dataIndex: "frequency",
      width: "12%",
      render: (_, row) => (
        <div style={{ textAlign: "center" }}>
          <Tag>
            <div style={{ textAlign: "center" }}>

              <span style={{
                fontSize: "13px",
                fontWeight: "300", fontSize: "13px",
              }}>{row.frequency}</span>

            </div>
          </Tag>

        </div>
      ),
    },
    {
      title: renderTitle("Depth"),
      dataIndex: "depth",
      width: "7%",
      render: (_, render) => (
        <>
          <span>{renderPara(render.depth, 'center')}</span>
        </>
      ),
    },
    {
      title: " ",
      dataIndex: "source",
      width: "5%",
      render: (_, render) => (
        <>
          <span>{renderActionButton(render)}</span>
        </>
      ),
    },
  ];
  const onChange = (pagination, filters, sorter, extra) => {
    setTableParams({ pagination: { pagination } });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div style={{ width: '100%', margin: 'auto' }}>
      <div
        className="mb-2 mt-2"
        style={{
          display: "flex",
          boxShadow: "7px 7px 20px lightgrey",
          backgroundColor: "#FAFAFA",
          justifyContent: "space-between",
          border: "1px solid #FAFAFA",
          alignItems: "center",
          borderRadius: "6px",
          padding: "8px",
        }}
      >
        <div style={{ display: "flex" }}>
          <span>
        
                  <Input
                          allowClear
                          style={containerStyles} 
                          value={tabSearch}
                           prefix={<SearchOutlined style={{color:'#ACB6C6'}} />} 
                          onChange={(val) => onChangeFilterStr(val.target.value)}
                         placeholder="Search for document..."
                        />
          </span>
        </div>
        <div>
          <span>
            <Tooltip title={tooltipTitle("Refresh List")} color="#fafafa">
              <SyncOutlined
                colSpan={3}
                span={2}
                onClick={() => refreshData()}
                spin={isRefreshing}
                style={{ fontSize: "16px" }}
              />
            </Tooltip>
          </span>
        </div>
      </div>
      <Spin spinning={isLoading}>
        <Table
          rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
          columns={columns}
          showSorterTooltip={false}
          dataSource={rows}
          rowKey={(record) => record}
          onChange={onChange}
          pagination={false}
          expandable={{
            expandedRowRender: (record) => (
              <ul
                style={{
                  margin: 0,
                  wordBreak: 'break-word', overflowWrap: 'break-word',
                  fontSize: '12px'
                }}
              >
                {record.childLink.split(',').map(link => {
                  return (
                    <li><a href={link} style={{ textDecoration: 'none' }} target="_blank">{link}</a></li>
                  )
                })}
              </ul>
            ),
            rowExpandable: (record) => record.childLink.length !== 0,
          }}
          className="mb-5"
          style={{ boxShadow: "7px 7px 20px lightgrey" }}
        />
      </Spin>
    </div>
  );
}
